import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Lock, User, Loader2, ShieldPlus } from "lucide-react";
import { useAuth } from "../lib/auth";
import { Input } from "../components/ui/input";
import { Button } from "../components/ui/button";
import { useToast } from "../hooks/use-toast";

const AdminLogin = () => {
  const { adminLogin, adminRegister, hasAdmin, ready } = useAuth();
  const { toast } = useToast();
  const navigate = useNavigate();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const isSetup = ready && !hasAdmin;

  const submit = async (e) => {
    e.preventDefault();
    if (!username.trim() || !password) return;
    setBusy(true);
    try {
      if (isSetup) {
        await adminRegister(username.trim(), password);
        toast({ title: "Admin angelegt", description: "Willkommen im Habthek-Backend." });
      } else {
        await adminLogin(username.trim(), password);
        toast({ title: "Eingeloggt", description: `Hallo ${username}` });
      }
      navigate("/admin");
    } catch (err) {
      toast({
        title: "Fehler",
        description: err?.response?.data?.detail || "Login fehlgeschlagen",
        variant: "destructive",
      });
    } finally {
      setBusy(false);
    }
  };

  return (
    <section className="mx-auto max-w-md px-4 py-20">
      <div className="rounded-2xl border border-white/10 bg-[#0f141b] p-8">
        <div className="flex items-center gap-2 text-[10px] font-semibold uppercase tracking-[0.22em] text-[#9d7bff]">
          {isSetup ? <ShieldPlus className="h-4 w-4" /> : <Lock className="h-4 w-4" />} Admin
        </div>
        <h1 className="mt-1 text-2xl font-bold text-white">
          {isSetup ? "Admin einrichten" : "Admin-Login"}
        </h1>
        <p className="mt-2 text-sm text-zinc-400">
          {isSetup
            ? "Lege jetzt deinen Admin-Account fuer die Habthek an."
            : "Melde dich an, um Habbos und Projekte zu verwalten."}
        </p>

        <form onSubmit={submit} className="mt-6 space-y-3">
          <div className="relative">
            <User className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-zinc-500" />
            <Input
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              placeholder="Benutzername"
              autoComplete="username"
              className="pl-9 bg-[#10141b] border-white/10 text-zinc-200"
            />
          </div>
          <div className="relative">
            <Lock className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-zinc-500" />
            <Input
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              type="password"
              placeholder="Passwort (min. 6 Zeichen)"
              autoComplete={isSetup ? "new-password" : "current-password"}
              className="pl-9 bg-[#10141b] border-white/10 text-zinc-200"
            />
          </div>
          <Button type="submit" disabled={busy} className="btn-primary w-full rounded-lg py-2 text-sm font-semibold">
            {busy ? <Loader2 className="mr-2 h-4 w-4 animate-spin" /> : null}
            {isSetup ? "Admin anlegen" : "Einloggen"}
          </Button>
        </form>
      </div>
    </section>
  );
};

export default AdminLogin;
